import { format } from 'date-fns';

/** Formats a date as the `yyyy-MM-dd` string the backend Date scalar expects. */
const inputDateFormatter = (date: Date): string =>
    format(new Date(date), 'yyyy-MM-dd');

export { inputDateFormatter };
